// extracted by mini-css-extract-plugin
export var button = "_bw-0";
export var donut = "_bw-1";
export var donutFill = "_bw-3";
export var donutTrack = "_bw-2";